module.exports = __webpack_public_path__ + "img/soja.678ee4da.svg";